export const repositoryURL = 'https://github.com/hixme/hixme-ui'

export function componentURL(component) {
  return `${repositoryURL}/tree/master/packages/${component}`
}



// WEBPACK FOOTER //
// ./src/modules/github-utils/index.js